import { Injectable } from '@angular/core';
import { SimpleLocation } from '../models/user';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  location: SimpleLocation;

  constructor() {}

  getLocation(): Observable<SimpleLocation> {
    const promise = new Promise<SimpleLocation>((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (loc) => {
          this.location = {
            lat: loc.coords.latitude,
            lng: loc.coords.longitude,
          };
          resolve(this.location);
        },
        () => {},
        { enableHighAccuracy: true }
      );
    });

    return from(promise);
  }
}
